import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthStore } from '../auth/store/auth.store';

export const httpRequestsInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(AuthStore);
  const authReq = store.getAuthRequest(req);

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        store.logout();
      }
      return throwError(() => error);
    }),
  );
};
